export default '/build/9910919c.svg'